export enum RoundingStrategy {
  HalfUp = 0,
  HalfDown = 1,
  HalfEven = 2,
  Up = 3,
  Down = 4,
  Truncate = 5,
  Ceiling = 6,
  Floor = 7,
}
